import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from '@mui/material';
import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import Toaster from 'src/Toaster/Toaster';
import { Helmet } from 'react-helmet-async';
import { LoadingButton } from '@mui/lab';
import CommonMultipleSelectMembers from 'src/common/CommonMultipleSelectMembers';
import SelectGroupMemberList from '../group/SelectGroupMemberList';
import PostDataApis from 'src/common/FetchData/PostDataApis';

function CreateSMS({ handleClose }) {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();
  const { postData, loading, success } = PostDataApis('/api/admin/member-sms');
  const [meetingType, setMeetingType] = useState('');
  const Toast = Toaster();

  const [allMember, setAllMember] = useState<number[]>([]);
  const [groupId, setGroupId] = useState<number[]>([]);

  const onSubmit = async (inputs: any) => {
    if (!meetingType) {
      Toast.fire({
        icon: 'error',
        title: `Please select meeting type`,
      });
      return;
    }

    const body: {
      text: string;
      type: string;
      members?: number[];
      group_ids?: number[];
    } = {
      text: inputs?.text,
      type: meetingType,
    };
    if (meetingType === 'specific') {
      body.members = allMember;
    }
    if (meetingType === 'group') {
      body.group_ids = groupId;
    }
    await postData(body);
  };

  useEffect(() => {
    if (success) {
      handleClose(false);
    }
  }, [success]);
  return (
    <>
      <Helmet>
        <title>Atab - Create sms</title>
      </Helmet>

      <Box component='form' onSubmit={handleSubmit(onSubmit)} sx={{ px: 1 }}>
        <Grid container spacing={2}>
          <Grid xs={12} md={12} lg={12} item>
            <TextField
              fullWidth
              label='Write SMS'
              multiline
              required
              rows={4}
              id='outlined-required'
              type='text'
              aria-invalid={errors.member_meeting_detail ? 'true' : 'false'}
              helperText={
                errors.member_meeting_detail?.type === 'required' &&
                'Meeting details is required'
              }
              {...register('text')}
            />
          </Grid>

          <Grid xs={12} md={12} lg={12} item>
            <FormControl fullWidth>
              <InputLabel id='demo-simple-select-label'>
                Meeting type
              </InputLabel>
              <Select
                fullWidth
                labelId='demo-simple-select-label'
                id='demo-simple-select'
                value={meetingType}
                label=' Meeting type'
                onChange={(e) => setMeetingType(e.target.value)}
                required
              >
                <MenuItem value={'all'}>All</MenuItem>
                <MenuItem value={'specific'}>Specific</MenuItem>
                <MenuItem value={'group'}>Group</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          {meetingType === 'specific' && (
            <Grid xs={12} md={12} lg={12} item>
              <CommonMultipleSelectMembers
                onChange={(e) => {
                  setAllMember(e);
                }}
                label='Select Members'
                size='medium'
              />
            </Grid>
          )}
          {meetingType === 'group' && (
            <Grid xs={12} md={12} lg={12} item>
              <SelectGroupMemberList
                onChange={(e) => {
                  setGroupId(e);
                }}
                label='Select Group List'
                size='medium'
              />
            </Grid>
          )}

          <Grid xs={12} md={12} lg={12} item>
            {!loading ? (
              <Button
                type='submit'
                fullWidth
                variant='contained'
                disableElevation
              >
                Create
              </Button>
            ) : (
              <LoadingButton
                fullWidth
                loading
                loadingIndicator='Creating...'
                variant='contained'
                disabled
              >
                <span>Creating...</span>
              </LoadingButton>
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  );
}

export default CreateSMS;
